module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bg-light",
    attrs: {
      "id": "thankyou"
    }
  }, [_c('div', {
    staticClass: "project_info"
  }, [_c('div', {
    staticClass: "spaninput h2 medium c-dark"
  }, [(_vm.loggedIn) ? _c('span', {
    staticClass: "flexinputs"
  }, [_c('div', {
    staticClass: "input_block"
  }, [_c('span', {
    staticClass: "upcase c-dgrey h8 medium"
  }, [_vm._v("NOME PROGETTO")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.project_name),
      expression: "project_name"
    }],
    staticClass: "input_header",
    attrs: {
      "readonly": ""
    },
    domProps: {
      "value": (_vm.project_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.project_name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input_block"
  }, [_c('span', {
    staticClass: "upcase c-dgrey h8 medium"
  }, [_vm._v("CLIENTE")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.client_name),
      expression: "client_name"
    }],
    staticClass: "input_header",
    domProps: {
      "value": (_vm.client_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.client_name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "thank_size c-dgrey h6 regular"
  }, [_vm._v("\n\t\t\t\t\tL.\n\t\t\t\t\t"), _c('span', {
    staticClass: "medium"
  }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm.configurator === "krossing" ? _vm.krossingWidth : _vm.currentWidth) + "\n\t\t\t\t\t")]), _vm._v("\n\t\t\t\t\tH.\n\t\t\t\t\t"), _c('span', {
    staticClass: "medium"
  }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm.configurator === "krossing" ? _vm.krossingHeight : _vm.currentHeight) + "\n\t\t\t\t\t")])])]) : _vm._e(), _vm._v(" "), (!_vm.loggedIn) ? _c('span', [_vm._v("\n\t\t\t\t" + _vm._s(_vm.project_name) + "\n\t\t\t\t"), _c('div', {
    staticClass: "thank_size c-dgrey h6 regular"
  }, [_vm._v("\n\t\t\t\t\tL.\n\t\t\t\t\t"), _c('span', {
    staticClass: "medium"
  }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm.configurator === "krossing" ? _vm.krossingWidth : _vm.currentWidth) + "\n\t\t\t\t\t")]), _vm._v("\n\t\t\t\t\tH.\n\t\t\t\t\t"), _c('span', {
    staticClass: "medium"
  }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm.configurator === "krossing" ? _vm.krossingHeight : _vm.currentHeight) + "\n\t\t\t\t\t")])])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "screenshot",
    style: (_vm.imageStyle())
  }, [(!_vm.project) ? _c('div', {
    staticClass: "miniloader"
  }, [_c('miniloader')], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "container_info"
  }, [(!_vm.loggedIn) ? _c('button', {
    staticClass: "emailbtn bg-accent c-light h7 bold upcase",
    on: {
      "click": _vm.sendEmail
    }
  }, [_c('img', {
    attrs: {
      "src": "/images/email.svg"
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('contact')))])]) : _vm._e(), _vm._v(" "), (_vm.loggedIn) ? _c('button', {
    staticClass: "savebtn bg-accent c-light h7 bold upcase",
    on: {
      "click": _vm.save_project
    }
  }, [_c('img', {
    attrs: {
      "src": "/images/arrow_white.svg"
    }
  }), _vm._v("\n\t\t\t\t" + _vm._s(_vm.$t("save_project")))]) : _vm._e(), _vm._v(" "), (!_vm.loggedIn) ? _c('button', {
    staticClass: "resellersbtn bg-light c-accent h7 bold upcase",
    on: {
      "click": _vm.openResellers
    }
  }, [_c('img', {
    attrs: {
      "src": "/images/resellers.svg"
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('resellers')))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "link"
  }, [_c('span', {
    staticClass: "upcase c-dgrey h8 medium"
  }, [_vm._v("LINK")]), _vm._v(" "), _c('span', {
    staticClass: "link_span selectable"
  }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm.link) + "\n\t\t\t\t\t")])]), _vm._v(" "), _c('div', {
    staticClass: "share"
  }, [_c('span', {
    staticClass: "medium h8 c-dgrey upcase"
  }, [_vm._v(_vm._s(_vm.$t('share')))]), _vm._v(" "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": ("https://www.facebook.com/sharer/sharer.php?u=" + (encodeURI(_vm.link)))
    }
  }, [_c('img', {
    attrs: {
      "src": "/images/fb.svg"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": ("https://twitter.com/home?status=" + (encodeURI(_vm.link)))
    }
  }, [_c('img', {
    attrs: {
      "src": "/images/tw.svg"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": ("https://pinterest.com/pin/create/button/?url=" + (encodeURI(_vm.link)) + "&media=" + (encodeURI(_vm.image)) + "&description=" + (encodeURI('My Kriptonite')))
    }
  }, [_c('img', {
    attrs: {
      "src": "/images/pin.svg"
    }
  })]), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.shareViaEmail
    }
  }, [_c('img', {
    attrs: {
      "src": "/images/mail_thankyou.svg"
    }
  })])])])]), _vm._v(" "), (!_vm.is_touch()) ? _c('div', {
    staticClass: "bottombar bg-lgrey"
  }, [_c('button', {
    staticClass: "c-dark h7 regular upcase",
    class: {
      disabled: !_vm.project
    },
    on: {
      "click": _vm.downloadModel
    }
  }, [_c('img', {
    attrs: {
      "src": "/images/arrow.svg"
    }
  }), _vm._v(_vm._s(_vm.$t('downloadobj')))]), _vm._v(" "), _c('button', {
    staticClass: "c-dark h7 regular upcase",
    class: {
      disabled: !_vm.project
    },
    on: {
      "click": _vm.projectDetails
    }
  }, [_c('img', {
    attrs: {
      "src": "/images/arrow.svg"
    }
  }), _vm._v(_vm._s(_vm.$t('downloadpf')))])]) : _vm._e(), _vm._v(" "), (_vm.is_touch()) ? _c('div', {
    staticClass: "bottombar bottombar-ext bg-lgrey"
  }, [_c('button', {
    staticClass: "c-dark h7 regular upcase",
    class: {
      disabled: !_vm.project
    },
    on: {
      "click": _vm.projectDetails
    }
  }, [_vm._v(_vm._s(_vm.$t('downloadpf')))])]) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "showpopup"
    }
  }, [(_vm.isEmailPopupVisible) ? _c('div', {
    staticClass: "sharepopup_container",
    on: {
      "click": _vm.closeEmailPopup
    }
  }, [_c('div', {
    staticClass: "sharepopup"
  }, [_c('span', {
    staticClass: "h7 medium c-dark upcase"
  }, [_vm._v("A chi vuoi inviare il progetto?")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sendToEmailSharePopup),
      expression: "sendToEmailSharePopup"
    }],
    staticClass: "shareinput h7 medium c-dark",
    attrs: {
      "type": "text",
      "placeholder": "Inserisci qui la email"
    },
    domProps: {
      "value": (_vm.sendToEmailSharePopup)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.sendToEmailSharePopup = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "medium h7 c-accent upcase",
    on: {
      "click": _vm.sendShareEmail
    }
  }, [_vm._v("\n\t\t\t\t\tInvia\n\t\t\t\t")])])]) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "showpopup"
    }
  }, [(_vm.isThankyoupopupVisible) ? _c('div', {
    staticClass: "sharepopup_container",
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        _vm.hidePopup($event)
      }
    }
  }, [_c('div', {
    staticClass: "sharepopup"
  }, [_c('span', {
    staticClass: "h7 medium c-dark upcase"
  }, [_vm._v(_vm._s(_vm.$t("thanks")))]), _c('br'), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "h9 c-dark"
  }, [_vm._v(_vm._s(_vm.$t("saved")))]), _c('br'), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "medium h7 c-accent upcase",
    on: {
      "click": _vm.hidePopup
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(_vm.$t("close")) + "\n\t\t\t\t\t\t")])])]) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-65942ade"}!./~/vue-loader/lib/selector.js?type=template&index=0!./app/components/views/Thankyou.vue
// module id = 640
// module chunks = 0